import type { ReactNode } from 'react'
import { Boxes } from 'lucide-react'

// 로그인 전 화면들의 공통 카드: 제품 표시 아래에 입력 몇 개 또는 문장 하나.

export function AuthCard({ title, children, onSubmit }: { title: string; children: ReactNode; onSubmit?: (e: React.FormEvent) => void }) {
  return (
    <div className="grid h-full place-items-center">
      <form onSubmit={onSubmit ?? ((e) => e.preventDefault())} className="grid w-full max-w-72 gap-3 px-4">
        <div className="mb-2 flex items-center gap-2.5">
          <span className="flex size-9 items-center justify-center rounded-lg bg-brand text-white">
            <Boxes className="size-4.5" />
          </span>
          <span className="grid leading-tight">
            <span className="font-semibold tracking-tight">{title}</span>
            <span className="text-[11px] text-muted-foreground">Leorca Cluster Control System</span>
          </span>
        </div>
        {children}
      </form>
    </div>
  )
}
